import React from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";

const AdminOffer = () => {
  return (
    <>
      <div className="main-wrapper">
        <Header />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="row">
              <div className="col-xl-12 col-12">
                <div className="card rounded-1 card-table">
                  <div className="card-header py-3">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title">Offers</h5>
                      </div>
                      <div className="col-auto">
                        <div className="d-flex gap-3">
                          <button className="btn btn-success">
                            Export as CSV
                          </button>
                          <button className="btn btn-warning">
                            Bulk CSV Upload
                          </button>
                          <button
                            className="btn btn-primary"
                            data-bs-toggle="modal"
                            data-bs-target="#addnewModal"
                          >
                            Add New
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-striped table-hover">
                        <thead className="thead-light">
                          <tr>
                            <th>Id</th>
                            <th>Cover</th>
                            <th>Coupon code</th>
                            <th>Discount</th>
                            <th>Expire</th>
                            <th>Short Description</th>
                            <th>Min</th>
                            <th>Upto</th>
                            <th>Manage By</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>
                              <img
                                src="assets/img/dummy.jpeg"
                                className="rounded border"
                                alt=""
                                width="50"
                                height="50"
                              />
                            </td>
                            <td>2020</td>
                            <td>20 %</td>
                            <td>Oct 27, 2022 12:00 AM</td>
                            <td>
                              20% off in minimum spend
                              <br /> of $100
                            </td>
                            <td>100</td>
                            <td>25</td>
                            <td>Admin</td>
                            <td>
                              <a href="#" className="btn btn-sm btn-success">
                                Active
                              </a>
                              <a href="#" className="btn btn-sm btn-primary">
                                View
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>
                              <img
                                src="assets/img/dummy.jpeg"
                                className="rounded border"
                                alt=""
                                width="50"
                                height="50"
                              />
                            </td>
                            <td>2020</td>
                            <td>20 %</td>
                            <td>Oct 27, 2022 12:00 AM</td>
                            <td>
                              20% off in minimum spend
                              <br /> of $100
                            </td>
                            <td>100</td>
                            <td>25</td>
                            <td>Admin</td>
                            <td>
                              <a href="#" className="btn btn-sm btn-success">
                                Active
                              </a>
                              <a href="#" className="btn btn-sm btn-primary">
                                View
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>
                              <img
                                src="assets/img/dummy.jpeg"
                                className="rounded border"
                                alt=""
                                width="50"
                                height="50"
                              />
                            </td>
                            <td>2020</td>
                            <td>20 %</td>
                            <td>Oct 27, 2022 12:00 AM</td>
                            <td>
                              20% off in minimum spend
                              <br /> of $100
                            </td>
                            <td>100</td>
                            <td>25</td>
                            <td>Admin</td>
                            <td>
                              <a href="#" className="btn btn-sm btn-success">
                                Active
                              </a>
                              <a href="#" className="btn btn-sm btn-primary">
                                View
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>
                              <img
                                src="assets/img/dummy.jpeg"
                                className="rounded border"
                                alt=""
                                width="50"
                                height="50"
                              />
                            </td>
                            <td>2020</td>
                            <td>20 %</td>
                            <td>Oct 27, 2022 12:00 AM</td>
                            <td>
                              20% off in minimum spend
                              <br /> of $100
                            </td>
                            <td>100</td>
                            <td>25</td>
                            <td>Admin</td>
                            <td>
                              <a href="#" className="btn btn-sm btn-success">
                                Active
                              </a>
                              <a href="#" className="btn btn-sm btn-primary">
                                View
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>
                              <img
                                src="assets/img/dummy.jpeg"
                                className="rounded border"
                                alt=""
                                width="50"
                                height="50"
                              />
                            </td>
                            <td>2020</td>
                            <td>20 %</td>
                            <td>Oct 27, 2022 12:00 AM</td>
                            <td>
                              20% off in minimum spend
                              <br /> of $100
                            </td>
                            <td>100</td>
                            <td>25</td>
                            <td>Admin</td>
                            <td>
                              <a href="#" className="btn btn-sm btn-success">
                                Active
                              </a>
                              <a href="#" className="btn btn-sm btn-primary">
                                View
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="d-flex flex-column flex-sm-row align-items-center justify-content-between">
                      <p className="text-dark">Showing 1 to 3 of 20 entries</p>
                      <nav aria-label="...">
                        <ul className="pagination">
                          <li className="page-item disabled">
                            <a className="page-link" href="#" tabindex="-1">
                              Previous
                            </a>
                          </li>
                          <li className="page-item">
                            <a className="page-link" href="#">
                              1
                            </a>
                          </li>
                          <li className="page-item active">
                            <a className="page-link" href="#">
                              2 <span className="sr-only">(current)</span>
                            </a>
                          </li>
                          <li className="page-item">
                            <a className="page-link" href="#">
                              3
                            </a>
                          </li>
                          <li className="page-item">
                            <a className="page-link" href="#">
                              Next
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminOffer;
